import { Box } from '@mui/material';

import { Skeleton } from '@/components';

import { EpisodeCardJumboDimensions } from '../../constants';

export const EpisodeCardJumboSkeleton = () => (
  <Box
    sx={{
      width: EpisodeCardJumboDimensions.width,
      height: EpisodeCardJumboDimensions.height,
    }}>
    <Skeleton
      variant="rounded"
      width="auto"
      sx={{
        height: EpisodeCardJumboDimensions.height,
        borderRadius: 4,
      }}
    />
  </Box>
);
